import PropTypes from 'prop-types';
import { createContext, useContext, useEffect,useState } from 'react';

// import moment from "moment";
// import { useGlobalContext } from "./GlobalContext";
import { fetchStatusTasks, fetchTasks } from '../../Api/suiviMission/tasks';
import { useGlobalContext } from './GlobalContext';

const TaskContext = createContext();

export function TaskContextProvider({ children }) {
    TaskContextProvider.propTypes = {
        children: PropTypes.any,
    };
    //currently tracked mission
    const [tasks, setTasks] = useState([]);
    const [todoTasks, settodoTasks] = useState([]);
    const [inprogressTasks, setinprogressTasks] = useState([]);
    const [doneTasks, setdoneTasks] = useState([]);

    const { mission } = useGlobalContext();
    useEffect(() => {
        console.log('fetchTasks is called');
        fetchTasks(setTasks, mission._id);
        //   for(let task in tasks) {
        //     if(moment(task.dateFin).valueOf() <  moment().valueOf()){
        //       tasks[task].overdue = true ;
        //       console.log(tasks[task]);
        //     }
        //  ;
        //   }
    }, [
        // tasks,
        todoTasks, doneTasks, inprogressTasks]);
    useEffect(() => {
        console.log('fetchStatusTasks TODO is called');
        fetchStatusTasks(settodoTasks, mission._id, 'to do');

    }, []);
    useEffect(() => {
        console.log('fetchStatusTasks in progress is called');
        fetchStatusTasks(setinprogressTasks, mission._id, 'in progress');

    }, []);
    useEffect(() => {
        console.log('fetchStatusTasks done is called');
        fetchStatusTasks(setdoneTasks, mission._id, 'done');

    }, []);

    return (
        <TaskContext.Provider
            value={{
                tasks,
                setTasks,
                todoTasks,
                settodoTasks,
                inprogressTasks,
                setinprogressTasks,
                doneTasks,
                setdoneTasks,
            }}
        >
            {children}
        </TaskContext.Provider>
    );
}

export const useTaskContext = () => useContext(TaskContext);
